import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  paper: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  rootActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(4),
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
}));
